import { useAuthStore } from '~/stores/auth';
import { useAppStore } from '~/stores/app';
import { useCookieStore } from '~/stores/cookie';
export default (function (context, inject) {
  var auth = useAuthStore();
  var app = useAppStore();
  var cookies = useCookieStore();
  function clickHandler() {
    if (typeof window == 'undefined') return;
    HelpCrunch('closeChat');
  }
  function _init() {
    var _auth$user, _auth$user$helpCrunch, _auth$user2, _auth$user2$helpCrunc;
    var user = (_auth$user = auth.user) !== null && _auth$user !== void 0 && (_auth$user$helpCrunch = _auth$user.helpCrunch) !== null && _auth$user$helpCrunch !== void 0 && _auth$user$helpCrunch.user ? auth.user.helpCrunch.user : null;
    window.helpcrunchSettings = {
      organization: 'casesmedia',
      appId: '980477f5-ed8a-411f-b840-ffd2e7d4eedf',
      user: user,
      isEmbedded: true // (ховає кнопку віджета і нотифікації навіть при відкритому віджеті)
      //showEmbeddedModeNotification: true //(показує нотифікації якщо isEmbedded: true)
    };
    if ((_auth$user2 = auth.user) !== null && _auth$user2 !== void 0 && (_auth$user2$helpCrunc = _auth$user2.helpCrunch) !== null && _auth$user2$helpCrunc !== void 0 && _auth$user2$helpCrunc.signature) {
      window.helpcrunchSettings.signature = auth.user.helpCrunch.signature;
    }
    (function (w, d) {
      var hS = w.helpcrunchSettings;
      if (!hS || !hS.organization) {
        return;
      }
      var widgetSrc = 'https://embed.helpcrunch.com/sdk.js';
      w.HelpCrunch = function () {
        w.HelpCrunch.q.push(arguments);
      };
      w.HelpCrunch.q = [];
      function loadScript() {
        if (d.querySelector('script[src="' + widgetSrc + '"]')) {
          return;
        }
        var s = d.createElement('script');
        s.async = true;
        s.type = 'text/javascript';
        s.src = widgetSrc;
        (d.body || d.head).appendChild(s);
      }
      if (d.readyState === 'complete' || hS.loadImmediately) {
        loadScript();
      } else if (w.attachEvent) {
        w.attachEvent('onload', loadScript);
      } else {
        w.addEventListener('load', loadScript, false);
      }
    })(window, document);
    HelpCrunch('setPhraseList', context.app.i18n.locale);
    if (cookies.authState == 'loggedOut' && !auth.user) {
      HelpCrunch('logout');
      cookies.setState('authState', '');
    }
    HelpCrunch('onReady', function () {
      app.$patch({
        helpCrunchReady: true
      });
      if (app.helpCrunchOpen) HelpCrunch('openChat');else HelpCrunch('closeChat');
    });
    HelpCrunch('onChatOpen', function () {
      app.$patch({
        helpCrunchOpen: true
      });
      document.addEventListener('click', clickHandler);
    });
    HelpCrunch('onChatClose', function () {
      app.$patch({
        helpCrunchOpen: false
      });
      document.removeEventListener('click', clickHandler);
    });
    HelpCrunch('onNewUnreadChat', function (event) {
      app.$patch({
        helpCrunchUnreadChats: event.unreadChats
      });
    });
  }
  var helpCrunch = {
    init: function init() {
      if (typeof window == 'undefined') return;
      _init();
    },
    setLocale: function setLocale(locale) {
      if (typeof window == 'undefined') return;
      HelpCrunch('setPhraseList', locale);
    },
    toggle: function toggle() {
      if (typeof window == 'undefined') return;
      if (app.helpCrunchOpen) {
        app.$patch({
          helpCrunchOpen: false
        });
        HelpCrunch('closeChat');
      } else {
        app.$patch({
          helpCrunchOpen: true
        });
        HelpCrunch('openChat');
      }
    }
  };

  // Make hotJar globally accessible
  inject('helpCrunch', helpCrunch);
  context.$helpCrunch = helpCrunch;
});